export default __webpack_public_path__ + "static/media/step-two-2.f80e4c5f.svg";